export default "__VITE_ASSET__BdZ6UE0___"